import { Pipe, PipeTransform } from '@angular/core';
import { AssignmentLevelType } from 'src/app/shared/models/enums/assignee-level-type.enum';

@Pipe({
    name: 'assignmentLevel',
    standalone: true
})
export class AssignmentLevelTypePipe implements PipeTransform {
    transform(value?: AssignmentLevelType): string {
        if (!value) {
            return 'Auto Assign Setting';
        } else if (value === AssignmentLevelType.Contract) {
            return 'Manual Contract Setting';
        } else if (value === AssignmentLevelType.Candidate) {
            return 'Candidate Setting';
        } else if (value === AssignmentLevelType.Recruiter) {
            return 'Recruiter Setting';
        } else if (value === AssignmentLevelType.Facility) {
            return 'Facility Setting';
        } else if (value === AssignmentLevelType.Agency) {
            return 'Association Setting';
        } else {
            return 'No Setting Found';
        }
    }
}
